module.exports = __webpack_public_path__ + "static/media/dubleBg.36a195ef.jpg";